import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { format } from 'owa-strings';
import { observer } from 'mobx-react';
import { showUnsubscribeDialog } from './UnsubscribeDialog';
import { unsubscribeFromBrandSubscription, useSilentUri } from 'owa-brands-subscription';

const styles = require('./BrandSubscriptionDetails.scss');

export interface BrandSubscriptionDetailsProps {
    displayName: string;
    smtp: string;
    smtpIdentifier: string;
    unsubscribeHttpUri: string;
    unsubscribeSilentUris: string[];
    isUnsubscribed: boolean;
}

@observer
export default class BrandSubscriptionDetails extends React.Component<
    BrandSubscriptionDetailsProps,
    {}
> {
    render() {
        return (
            <div className={styles.details}>
                <span className={styles.displayName} title={this.props.displayName}>
                    {this.props.displayName}
                </span>
                <span className={styles.smtp} title={this.props.smtp}>
                    {this.props.smtp}
                </span>
                {!this.props.isUnsubscribed && (
                    <ActionButton
                        styles={{
                            label: styles.buttonLabel,
                            rootHovered: styles.buttonHovered,
                        }}
                        text={strings.options_subscriptions_unsubscribe}
                        className={styles.button}
                        onClick={this.onUnsubscribe}
                    />
                )}
            </div>
        );
    }

    private onUnsubscribe = (ev: React.MouseEvent<EventTarget>) => {
        const unsubscribeCallback = () => {
            unsubscribeFromBrandSubscription(
                'SubscriptionHub',
                this.props.smtpIdentifier,
                this.props.unsubscribeSilentUris,
                this.props.unsubscribeHttpUri
            );
        };
        showUnsubscribeDialog(unsubscribeCallback, this.getDialogDetailMessage());
    };

    private getDialogDetailMessage = (): string => {
        return useSilentUri(this.props.unsubscribeSilentUris.length)
            ? format(
                  strings.options_subscriptions_unsubscribeDialogDetails_SilentUriUnsubscribe,
                  this.props.displayName
              )
            : format(
                  strings.options_subscriptions_unsubscribeDialogDetails_HttpUriUnsubscribe,
                  this.props.displayName,
                  this.props.unsubscribeHttpUri
              );
    };
}
